import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { CardRowState } from 'tessa/cards';
import { CdFdProcessHelper } from 'src/cdScripts/Helpers/CdFdProcessHelper';
import { CdTaskTypes } from 'src/cdScripts/Helpers/CdTaskTypes';
import { createTypedField, DotNetType, Guid, TypedField } from 'tessa/platform';
import { CardRequest, CardService } from 'tessa/cards/service';
import { CdRequestTypes } from 'src/cdScripts/Helpers/CdRequestTypes';
import { showConfirm, showNotEmpty } from 'tessa/ui/tessaDialog';


export class CdAdditionalWorksContractOrderTaskUIExtension extends CardUIExtension {

    private _disposer: Function | null = null;

    public async initialized(context: ICardUIExtensionContext) {
        if (context.model == null ||
            context.model.card == null) {
            return;
        }
    }

    public async saving(context: ICardUIExtensionContext) {
        if (context.model == null
            || context.model.card == null) {
            return;
        }

        let card = context.model.card;
        let tasks = context.card.tasks;
        if (!Guid.equals(card.typeId, CdCardTypes.PkAdditionalWorksContractOrderTypeID) || tasks == null || tasks.length < 1) {
            return;
        }

        let taskTypesForChecking =
            [
                CdTaskTypes.PkAWCORvrBlockFillTypeID,
                CdTaskTypes.PkAWCORvrBlockFillConfirmationTypeID
            ] as string[];

        let taskCompletionOptionsForChecking = [
            CdFdProcessHelper.Approve,
            CdFdProcessHelper.Confirm
        ] as string[];

        if (!tasks.find(t => taskTypesForChecking.some(x => Guid.equals(t.typeId, x))
            && t.state == CardRowState.Deleted
            && t.optionId != null
            && taskCompletionOptionsForChecking.some(x => Guid.equals(t.optionId, x)))) {
            return;
        }

        // Свяжем РВР с виновнымы и обернем в модель
        let rvrList = card.sections.tryGet('PkAdditionalWorksContractOrderRvrList');
        let guiltySection = card.sections.tryGet('PkAdditionalWorksContractOrderRvrGuilty');
        let partnerReasonList: { ReasonID: TypedField, PartnerExternalID: TypedField }[] = []
        rvrList!.rows.forEach(rvrRow => {
            if (rvrRow.state != CardRowState.Deleted) {
                guiltySection!.rows.forEach(guiltyRow => {
                    if (guiltyRow.state != CardRowState.Deleted && rvrRow.tryGet("RowID") == guiltyRow.tryGet("ParentRvrRowID")) {
                        partnerReasonList.push({ ReasonID: createTypedField(rvrRow.tryGet("ARFOIssueReasonID"), DotNetType.Guid), PartnerExternalID: createTypedField(guiltyRow.tryGet("GuiltyPartyExternalID"), DotNetType.Int64) });
                    }
                });
            }
        });

        const request = new CardRequest();
        request.requestType = CdRequestTypes.CheckSettingsLegalEntitiesRequest;
        request.info["PartnerReasonList"] = partnerReasonList;

        const response = await CardService.instance.request(request);
        await showNotEmpty(response.validationResult.build());
        if (!response.validationResult.isSuccessful) {
            context.cancel = true;
            return;
        }
        else {
            let isPartnerValid: boolean = response.info.IsPartnerValid.$value;
            let message: string = response.info.Message.$value;

            if (isPartnerValid === false) {
                const result = await showConfirm(message + "\r\n\r\nПродолжить согласование без внесения изменений в карточке по Виновному/Причине?", "Предупреждение");
                if (!result) {
                    context.cancel = true;
                    return;
                }
            }
        }
    }

    public finalized() {
        // подчищаем за собой
        if (this._disposer) {
            this._disposer();
            this._disposer = null;
        }
    }
}